<template>
  <el-dialog
    title="编辑子账号"
    :visible.sync="editVisible"
    width="40%"
    :before-close="handleClose"
    center
  >
    <!-- 表单 -->
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="120px"
      class="demo-ruleForm"
    >
    <div class="title" style="marginLeft:5px;marginBottom:20px;fontWeight:bold;fontSize:16px">
        员工信息
    </div>
      <el-form-item label="子账号角色:" prop="role_id">
        <el-select style="width: 100%;height: 25px;" size="small" v-model="ruleForm.role_id" placeholder="请选择子账号角色">
            <el-option v-for="(item, index) in roleList" :key="index" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="员工姓名:" prop="name">
         <el-input size="small" v-model="ruleForm.name" placeholder="请输入员工姓名"></el-input>
      </el-form-item>
      <el-form-item label="联系微信:" prop="wx_num">
         <el-input size="small" v-model="ruleForm.wx_num" placeholder="请输入联系微信"></el-input>
      </el-form-item>
      <el-form-item label="微信二维码:">
        <div class="form-item">
            <input id="fileInput" type="file" name="file" accept="image/gif,image/jpeg,image/jpg,image/png,image/svg" @change="upload($event)">
            <label for="fileInput" class="file-btn">点击上传</label>
            <img v-if="ruleForm.wx_code!=''" style="width:80px;height:80px;" class="image" :src="ruleForm.wx_code" alt="">
        </div>
        <div>
            <span style="color:#8A8E99;fontSize:12px;">建议上传1:1比例的企业/个人微信二维码</span>
        </div>
      </el-form-item>
      <!-- upload -->
      <div class="title" style="marginLeft:10px;marginBottom:20px;fontWeight:bold;fontSize:16px">
          登陆账号
      </div>
      <el-form-item label="手机号码:" prop="phone">
         <el-input size="small" type="number" v-model="ruleForm.phone" placeholder="请输入手机号码"></el-input>
      </el-form-item>
      <el-form-item label="登陆密码:" prop="password">
        <el-input size="small" type="password" show-password v-model="ruleForm.password" placeholder="请输入登陆密码"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
        <el-button size="mini" style="backgroundColor:#F2F2F5;color:#45474D;borderColor:#FFFFFF" @click="handleClose">取 消</el-button>
        <el-button size="mini" style="backgroundColor:#fe2c55;color:#FFFFFF;borderColor:#FFFFFF" @click="handleConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>// @ts-nocheck

import { manageEdit,manageRoleList, manageUpload } from '@/api/manage.js'
export default {
  props: {
    editVisible: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  watch:{
    editVisible(val){
      if(val){
        // 每次打开重置表单校验
        this.$nextTick(()=>{
          this.$refs['ruleForm'].resetFields();
        })
        for(let key in this.ruleForm){
            this.ruleForm[key] = this.data[key]
        }
        this.ruleForm.wx_code = this.data.wx_code
      }else{
        this.ruleForm.wx_code = ''
      }
    }
  },
  mounted(){
    this.manageRoleList()
  },
  data() {
    return {
        src:'', // 商品链接
        ruleForm: {
          id:'',
          wx_uid:'',
          role_id: '',
          name: '',
          wx_num:'',
          phone:'',
          password:'',
          wx_code:'',
        },
        rules: {
          role_id: [
            { required: true, message: '请选择子账号角色', trigger: 'blur' },
          ],
          name:[
            { required: true, message: '请输入员工姓名', trigger: 'blur' },
          ],
          wx_num:[
            { required: true, message: '请输入联系微信', trigger: 'blur' },
          ],
          phone:[
            { validator: this.checkPhone, required: true, trigger: 'blur' },
          ],
          password:[
            { required: true, message: '请输入登陆密码', trigger: 'blur' },
          ]
        },
        roleList: []
    };
  },
  methods: {
    checkPhone(rule, value, callback) {
        if (!value) {
            callback(new Error('请输入联系人手机号'))
        } else {
            const reg = /^1[3|4|5|7|8|9][0-9]\d{8}$/; //手机号正则表达式
            //const reg = /^([0-9]{3,4}-)?[0-9]{7,8}$/; //座机号正则表达式
            //const reg =/^([1-9]{1})(\d{14}|\d{18})$/; //通用银行账号正则表达式
            //const reg = /^[1-9][0-9]{5}$/; //邮编正则表达式
            //const reg = /^(([0\+]\d{2,3}-)?(0\d{2,3})-)(\d{7,8})(-(\d{3,}))?$/;//传真正则表达式
            if (reg.test(value)) {
                callback()
            } else {
                return callback(new Error('请输入正确的手机号'))
            }
        }
    },
    // 获取员工角色列表
    manageRoleList(){
      manageRoleList({

      }).then( res => {
        if(res.code == 800){
          this.roleList = res.data
        }else{
          this.$message.error(res.msg)
        }
      } )
    },
    upload:function(e){
      // 图片显示
      var that = this;
      var imgObj = e.target.files[0];
      this.src=imgObj;
      var formData = new FormData();
      formData.append('file', this.src);
      formData.append('uid', '1');
      manageUpload(formData).then(res=>{
        if(res.code== 800){
            this.$message.success('上传成功')
            this.ruleForm.wx_code = res.data.images;
        }
      })
    },
    // 确认
    handleConfirm(){
      this.$refs['ruleForm'].validate( (valid) => {
        if( valid ){
          manageEdit({
              ...this.ruleForm
          }).then( res => {
              if(res.code==800){
                  this.$message.success(res.msg)
                  this.$emit('close','success')
              }else{
                  this.$message.error(res.msg)
              }
          })
        }else{
          console.log('error submit!!');
          this.$message.error('请完整填写!');
          return
        }
      })
    },
    // 关闭close
    handleClose() {
        this.$emit('close','cancel')
    },
  },
};
</script>

<style lang='scss' scoped>
  /deep/input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
  /deep/::-webkit-scrollbar {
    display: none !important;
  }
  /deep/.el-form-item__label{
      text-align: center;
  }
  /deep/.el-dialog__header{
      border-bottom: solid 1px #E6E7EB;
  }
  .form-item {
    width: 100%;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #333333;
    // margin-bottom: 20px;
}

.form-item label {
    width: 126px;
    text-align: right;
}

.form-item span {
    color: #FF3228;
}

.form-item input {
    width: 400px;
    height: 40px;
    line-height: 40px;
    border: 1px solid #cccccc;
    padding-left: 14px;
    box-sizing: border-box;
    margin-left: 18px;
}

/* 这是原生的input框，给他透明隐藏，然后定位让文件上传的按钮覆盖它 */
#fileInput {
    width: 120px;
    margin-left: 8px;
    filter: Alpha(opacity=0);
    -moz-opacity:0;
    opacity: 0;
    position: absolute;
    right: 37px;
    z-index: 2;
}
/* 这是主要的，文件上传按钮的样式 */
.file-btn {
    width: 100px;
    height: 32px;
    background: #FFFFFF;
    border: 1px solid #E6E7EB;
    border-radius: 4px;
    line-height: 32px;
    position: relative;
    text-align: center !important;
    cursor: pointer;
    top: 0;
    left: 0;
    margin-left: 0px;
    margin-right: 10px;
}
/* 单行文字截断，展示文件名的input框用的 */
#applyLicense {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>